import { pickLiveOrPreliveId, prepareEmptyMarket } from "../../helpers";
export const getMarkets = (marketsInConfig, markets, event) => {
    return marketsInConfig.map((config, index) => {
        const market = markets.find(market => market.marketType.id === pickLiveOrPreliveId(config, event.isLive));
        return market
            ? market
            : prepareEmptyMarket(event.id, config.template, index);
    });
};
//# sourceMappingURL=getMarkets.js.map